module.exports = __webpack_public_path__ + "src/assets/images/volums/sound/volum_circle2.png?5a4c9987f3cc9973a7f98b3ea9231fb8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volums/sound/volum_circle2.png
// module id = 661
// module chunks = 0